import { Button, Drawer, Form } from "antd";
import React, { memo } from "react";
import CenterHeader from "components/Misc/CenterHeader";
import styled from "styled-components";
import useDesktopDetection from "components/hooks/useDesktopDetection";
import IntlMessages from "components/Message/IntlMessages";
import { useDispatch, useSelector } from "react-redux";
import { NotificationSelector } from "redux/selector/notification";
import { notiTypes } from "./constant";
import { push } from "connected-react-router";
import { Routes } from "const";

function NotificationDrawer({ isVisible, setIsVisible, ...props }) {
  const dispatch = useDispatch();
  const isDesktop = useDesktopDetection();
  const notiList = useSelector(NotificationSelector.notificationList);

  const renderForm = () => {
    return (
      <FormStyled layout="vertical">
        <div className="body-notification">
          {notiList.map((item, index) => {
            if (item.types === notiTypes.riskProfile) {
              return (
                <div className="noti-list noti-message-new" key={index}>
                  <div className="bg-icon-noti">
                    <i className="feather-icon icon-bell" />
                    {/* ใช้กรณี Message ใหม่ */}
                    <div className="noti-badge" />
                  </div>
                  <div>
                    <div className="text-noti">{item.messageTh}</div>
                    <Button
                      type="primary"
                      shape="round"
                      className="btn button-ktb-line bg-white"
                      onClick={() => {
                        setIsVisible(false);
                        dispatch(push(Routes.Register.Suitability));
                      }}
                    >
                      ทำแบบประเมินใหม่
                    </Button>
                  </div>
                </div>
              );
            }
            return <></>;
          })}

          {/* <div className="noti-list">
            <div className="bg-icon-noti">
              <i className="feather-icon icon-tag translateX-1"></i>
            </div>
            <div>
              <div className="text-noti">
                เสนอขายหุ้นกู้ตลาดรอง <span>TBEV256A (AA+)</span> ขั้นต่ำ 100,000 บาท
              </div>
              <Button type="primary" shape="round" className="btn button-ktb-line bg-white">
                ดูรายละเอียด
              </Button>
            </div>
          </div>

          <div className="noti-list">
            <div className="bg-icon-noti">
              <i className="feather-icon icon-bell"></i>
            </div>
            <div>
              <div className="text-noti">
                <span>CB24118A</span> เงินต้น <span>100,000 บาท</span> จะครบกำหนดในวันที่ 01/02/2024
              </div>
              <Button type="primary" shape="round" className="btn button-ktb-line bg-white">
                ดูรายละเอียด
              </Button>
            </div>
          </div> */}
        </div>
        <Footer>
          <Button
            type="primary"
            shape="round"
            className="btn button-ktb-line"
            block
            onClick={() => setIsVisible(false)}
          >
            <IntlMessages id="notification.read-all" />
          </Button>
        </Footer>
      </FormStyled>
    );
  };

  return (
    <Drawer
      visible={isVisible}
      className="drawer-statement drawer-customize customize-header-width"
      title={
        <CenterHeader
          title={<IntlMessages id="notification.title" />}
          closeClassName="btn button-ktb-close"
          onBack={() => setIsVisible(false)}
          backable
        />
      }
      closable={false}
      onClose={() => {}}
      width={isDesktop ? 414 : "100vw"}
      placement="right"
      bodyStyle={{ padding: 0 }}
      destroyOnClose
      {...props}
    >
      {renderForm()}
    </Drawer>
  );
}

export default memo(NotificationDrawer);

const FormStyled = styled(Form)`
  height: 100%;
  .ant-form-item-label > label:first-child {
    width: 100%;
  }
  .body-notification {
    height: 100%;
    .noti-message-new {
      background: var(--ktb-blue-light-3);
    }
    .noti-list {
      padding: 12px 10px;
      display: flex;
      border-bottom: #ededed 1px solid;
      .text-noti {
        color: #003154;
        margin-bottom: 10px;
        font-family: "KrungthaiBold";
        span {
          color: #02b1ee;
          font-family: "KrungthaiExBold";
        }
      }
      .bg-icon-noti {
        background: #7d93a8;
        border-radius: 30rem;
        width: 36px;
        height: 36px;
        margin-right: 10px;
        flex: none;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        i {
          color: white;
          font-size: 16px;
        }
        .noti-badge {
          background-color: #ff5757;
          width: 12px;
          height: 12px;
          border: white 1px solid;
          border-radius: 30rem;
          position: absolute;
          top: -1px;
          right: -1px;
        }
      }
    }
  }
`;

const Footer = styled.div`
  position: sticky;
  bottom: 0px;
  left: 0px;
  right: 0px;
  padding: 16px;
  background-color: white;
`;
